{
  "login": {
    "pageTitle": "Login",
    "metaDescription": "Sign in to the Resource and Data Exchange (RDE) to access resources, datasets, and research projects."
  },
  "resource-explorer/search": {
    "pageTitle": "Resource Explorer",
    "metaDescription": "Search to discover informational resources and events."
  },
  "public-data-commons/search": {
    "pageTitle": "Public Data Commons",
    "metaDescription": "Search publicly available research projects and datasets in the Public Data Commons."
  },
  "private-data-enclave/search": {
    "pageTitle": "Private Data Enclave",
    "metaDescription": "Search and manage secure, private research datasets and projects."
  },
  "help": {
    "pageTitle": "Help",
    "metaDescription": "Start here for help and support in using the Resource and Data Exchange (RDE) platform."
  }
}
